<template>
    <div class="header" v-if="myindex">
        <div class="cont">
            <div class="item dis">
                <div class="item1 dis">
                    <div class="item_son"><router-link to="/">仪表天下首页</router-link> </div>
                    <div class="item_son"><router-link to="/about?type=1" target="_blank">知识与经验</router-link> </div>
                    <div class="item_son"><router-link to="/facility" target="_blank">仪表商城</router-link></div>
					<div class="item_son"><router-link to="/serve" target="_blank">专业服务</router-link></div>
					<div class="item_son"><router-link to="/about" target="_blank">行业资讯</router-link> </div>
                    <!-- <div class="item_son"><router-link to="/supplier" target="_blank">品牌供应商</router-link></div> -->
                </div>
                <div class="item2 dis">
                    <div class="item2_son img1 dis" @click="navi('/user/news')">
                        <img src="@/assets/icon/tz.png" alt="">
                        <div><router-link to="#">通知</router-link></div>
                    </div>
                    <div class="item2_son img2 dis" @click="navi('/user')">
                        <img src="@/assets/icon/user.png" alt="">
                        <div><router-link to="#">个人中心</router-link> </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="cont2">
            <div class="item2 dis">
                <div class="item3 dis">
                    <div class="logo">
                        <a href="./">
                            <img class="img1" :src="myindex.site_trademark" alt=""></img>
                        </a>
                    </div>
                    <!-- 地址 -->
                   <!-- <div class="location dis">
                        <img class="img2" src="@/assets/icon/location.png" alt="">
                        <div>{{city}}</div>
                    </div> -->
                    <!-- 输入框 -->
                    <div class="search">
                        <!-- 上面 -->
                        <div class="seaItem">
                            <div class="seaCont1 ">
                                <el-dropdown >
                                    <span class="el-dropdown-link">
                                        {{seaStr.name}}<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item 
                                            @click.native="setSea(p)"
                                            v-for="(p,i) in searchArr.slice(0,4)"
                                            :key="i"
                                        >{{p.name}}</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                            <div class="seaCont2">
                                 <input class="seainput" v-model="input" placeholder="请输入产品名称"/> 
                            </div>
                            <div class="seaCont3 dis" @click="searchstr(seaStr)">
                                <img src="@/assets/icon/search.png" alt="">
                                <div>搜全站</div>
                            </div>
                        </div>
                        <!-- 底部 -->
                        <div class="seaHistory">
                            <div v-for="(p,i) in hostArr" :key="i" @click="navihos(p)">{{p.name}}</div>
                            <!-- <div>测温仪</div>
                            <div>示波器</div>
                            <div>高性能测试仪器</div>
                            <div>音频分析仪</div> -->
                        </div>
                    </div>
                </div>
                <!-- 二维码图 -->
                <div class="demo-image__preview">
                    <el-image 
                        style="width: 64px; height: 64px"
                        :src="myindex.site_ewm" 
                        :preview-src-list="srcList">
                    </el-image>
                </div>
                <!-- <img class="img3" :src=" myindex.site_ewm" alt=""> -->
            </div>
            <div class="itemTitle dis" v-if="off">
                <div    
                    v-for="(p,i) in titleArr" :key="i"
                    :class="titleNum==i?'titleCheck':''"
                    @click="getTieleNum(i,p)">{{p.cont}}</div>
            </div>
        </div>
    </div>
</template>
<script>
import { search_type, hot_key, user } from "@/api/api";
import axios from "axios";
export default {
  name: "YbpcHeader",
  props: ["myindex"],
  data() {
    return {
      //seaArr: ["资讯", "服务", "仪器", "供应商"], // 资讯下拉数组
	  seaArr: ["资讯", "服务", "仪器"], // 资讯下拉数组
      seaStr: "资讯", //资讯选中
      input: "", //搜索输入框
      titleArr: [
        { cont: "首页", router: "/" },
        { cont: "知识与经验", router: "/about?type=1" },
        { cont: "仪表商城", router: "/facility" },
		{ cont: "专业服务", router: "/serve" },
		{ cont: "行业资讯", router: "/about" },
        // { cont: "品牌供应商", router: "/supplier" },
      ],
      titleNum: 0,
      off: false,
      // myindex:{},
      city: "郑州",
      searchArr: [],
      hostArr: [], //热门词汇
      loginOff: false,
      srcList: [this.myindex.site_ewm],
    };
  },
  watch: {
    $route(to, from) {
      if (to.name == "首页") {
        this.off = true;
      } else {
        this.off = false;
      }
    },
  },
  mounted() {
    if (this.$route.name == "首页") {
      this.off = true;
    }
    axios({
      url: "https://restapi.amap.com/v3/ip?parameters",
      method: "GET",
      params: { key: "460497e7496bfc77a44c2703754fbf4d" },
    }).then((res) => {
      this.city = res.data.city;
    });
    // 获取搜索类型
    search_type().then((res) => {
      this.searchArr = res.data;
      this.seaStr = this.searchArr[0];
      if (this.$route.query.seaid) {
        this.searchArr.map((res) => {
          if (res.id == this.$route.query.seaid) {
            this.seaStr = res;
          }
        });
      }
    });
    // 热门词汇
    hot_key().then((res) => {
      this.hostArr = res.data;
    });
    if (this.$route.query.search) {
      this.input = this.$route.query.search;
    }
    // 获取是否登录
    user()
      .then((res) => {
        res.code == "1" ? (this.loginOff = true) : "";
      })
      .catch((res) => {
        this.loginOff = false;
      });
  },

  methods: {
    setSea(str) {
      //修改搜索类型
      // console.log(str)
      this.seaStr = str;
    },
    getTieleNum(num, obj) {
      //修改选中标题
      // this.titleNum=num
      this.$router.push(obj.router);
    },
    searchstr(obj) {
      if (this.input == "") {
        // alert('请输入搜索内容');
        this.$message({
          message: "请输入搜索内容",
          type: "warning",
        });
        // this.$message.error('请输入手机号');
        return;
      }
      let src = "";
      // if (obj.id == "1") {
      //   src = `/supplierseach?search=${this.input}&seaid=${obj.id}`;
      // }
      // if (obj.id == "2") {
      //   src = `/news?search=${this.input}&seaid=${obj.id}`;
      // }
      // if (obj.id == "3") {
      //   src = `/serves?search=${this.input}&seaid=${obj.id}`;
      // }
      // if (obj.id == "4") {
      //   src = `/seafacility?search=${this.input}&seaid=${obj.id}`;
      // }
	  if (obj.id == "1") {
	    src = `/about?search=${this.input}&seaid=${obj.id}`;
	  }
	  if (obj.id == "2") {
	    src = `/serves?search=${this.input}&seaid=${obj.id}`;
	  }
	  if (obj.id == "3") {
	    src = `/seafacility?search=${this.input}&seaid=${obj.id}`;
	  }
	  if (obj.id == "4") {
	    src = `/about?type=1&search=${this.input}&seaid=${obj.id}`;
	  }
	  
      // console.log(obj , src)
      this.$router.push(src);
      if (src.split("?")[0] == this.$route.path) {
        this.$router.go(0);
      }
    },
    // 热门词汇跳转
    navihos(obj) {
      let src = "";
      if (!this.loginOff) {
        if ((obj.type_list == "1") | (obj.type_list == "2")) {
        } else {
          this.$notify({
            title: "提示",
            message: "请登录后再查看",
            duration: 2000,
          });
          return;
        }
      }
      if (obj.type_list == "1") {
        src = `/serve/detail?id=${obj.info_id}`;
      }
      if (obj.type_list == "2") {
        src = `facility/detail?id=${obj.info_id}`;
      }
      if (obj.type_list == "3") {
        src = `/about/detail?id=${obj.info_id}&sid=1&num=1`;
      }
      if (obj.type_list == "4") {
        src = `/about/detail?id=${obj.info_id}&sid=2&num=2`;
      }
      if (obj.type_list == "5") {
        src = `/about/detail?id=${obj.info_id}&sid=3&num=3`;
      }
      if (obj.type_list == "6") {
        src = `/about/detail?id=${obj.info_id}&sid=4&num=4`;
      }
      this.$router.push(src);
      if (src.split("?")[0] == this.$route.path) {
        this.$router.go(0);
      }
      // this.$router.go(0)
    },
    // 个人中心跳转
    navi(src) {
      user()
        .then((res) => {
          this.$router.push(src);
        })
        .catch((res) => {
          this.$notify({
            title: "提示",
            message: "请登录后再查看",
            duration: 2000,
          });
        });
    },
  },
};
</script>
<style lang="less" scoped>
.header {
  text-align: center;
  width: 100%;
  border-bottom: 1px solid #e1e1e1;
  a {
    text-decoration: none;
    color: #666666;
  }
  .dis {
    display: flex;
    align-items: center;
  }
  .dis2 {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .cont {
    background: #f4f4f4;
    height: 30px;
    padding: 4px;
    box-sizing: border-box;
    .item {
      margin: 0 auto;
      justify-content: space-between;
      max-width: 1200px;
      cursor: pointer;
      .item1 {
        display: flex;
        .item_son:not(:last-child):after {
          content: "|";
          margin: 0 21px;
          color: #e1e1e1;
        }
      }
      .item2 {
        display: flex;
        .item2_son:not(:last-child):after {
          content: "|";
          margin: 0 21px;
          color: #e1e1e1;
        }
        img {
          height: 16px;
          margin-right: 7px;
        }
        .img1 {
          img {
            width: 13px;
          }
        }
        .img2 {
          img {
            width: 16px;
          }
        }
      }
    }
  }
  .cont2 {
    background: #fff;
    max-width: 1200px;
    margin: 0 auto;
    padding: 21px 0 11px;
    .item2 {
      justify-content: space-between;
      .item3 {
        .img1 {
          width: 100px;
          // height: 52px;
          margin-left: 15px;
        }
        .logo {
          padding-right: 23px;
          border-right: 1px solid #e1e1e1;
        }
        .location {
          padding: 18px 0;
          margin-left: 23px;
        }
        .img2 {
          width: 14px;
          height: 16px;
          margin-right: 6px;
        }
        .search {
          margin-left: 62px;
          .seaItem {
            width: 542px;
            border: 1px solid #e1251b;
            height: 38px;
            justify-content: space-between;
            display: flex;
          }
          .seaCont1 {
            cursor: pointer;
            // width: 87px;
			width: 120px;
            margin: 7px 0;
            border-right: 1px solid #e1e1e1;
            font-size: 14px;
            font-weight: 400;
            color: #181818;
            text-align: center;
            padding-top: 4px;
          }
          .seainput {
            :deep(.el-input__wrapper) {
              box-shadow: 0 0 0 0px
                var(--el-input-border-color, var(--el-border-color)) inset;
              cursor: default;
              .el-input__inner {
                cursor: default !important;
              }
            }
          }
          input:focus {
            outline: none;
          }
          .seaCont2 {
            width: 300px;

            padding: 13px 0;
            height: 12px;
            display: flex;
            align-items: center;
            .seainput {
              border: none !important;
              width: 100%;
              background: none;
              outline: none;
              border: 0px;
            }
            .seainput .el-input {
              border: none !important;
              width: 200px;
            }
          }
          .seaCont3 {
            background: #e1251b;
            color: #fff;
            padding: 0 14px;
            cursor: pointer;
            img {
              width: 14px;
              height: 14px;
              margin-right: 7px;
            }
          }
          .seaHistory {
            display: flex;
            margin-top: 13px;
            & > div:not(:first-child) {
              margin-left: 29px;
            }
            & > div:hover {
              color: #e1251b;
              cursor: pointer;
            }
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
          }
        }
      }
      .img3 {
        width: 64px;
        height: 64px;
      }
    }
    .itemTitle {
      margin-top: 35px;
      margin-left: 10px;
      & > div {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        margin-right: 85px;
        cursor: pointer;
      }
      :hover {
        color: #e1251b;
      }
      .titleCheck {
        color: #e1251b !important;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/head_foot/myHeader.vue